import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { ListParams } from 'models';
import { ViewerInfo } from 'models/viewers';

export interface ViewersState {
  loading: boolean;
  statusAdd: boolean;
  currentViewers?: ViewerInfo;
  error?: string;
}

const initialState: ViewersState = {
  loading: false,
  statusAdd: false,
  currentViewers: undefined,
  error: undefined,
};

const ViewersSlice = createSlice({
  name: 'Viewers',
  initialState,
  reducers: {
    fetchViewersInfo(state, action: PayloadAction<ViewerInfo>) {
      state.loading = true;
    },
    fetchViewersInfoSuccess(state, action: PayloadAction<ViewerInfo>) {
      state.loading = false;
      state.currentViewers = action.payload;
    },
    fetchViewersInfoFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    addPlantsToViewer(state, action: PayloadAction<ListParams>) {
      state.loading = true;
    },
    addPlantsToViewerSuccess(state) {
      state.loading = false;
      state.statusAdd = true;
      state.error = undefined;
    },
    addPlantsToViewerFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.statusAdd = false;
      state.error = action.payload;
    },
    resetViewerSlice(state) {
      state.loading = false;
      state.statusAdd = false;
      state.error = undefined;
    },
  },
});

export const ViewersActions = ViewersSlice.actions;

export const selectViewersError = (state: RootState) => state.ViewersReducer.error;
export const selectViewersLoading = (state: RootState) => state.ViewersReducer.loading;
export const selectStatusAdd = (state: RootState) => state.ViewersReducer.statusAdd;
export const selectViewersInfo = (state: RootState) => state.ViewersReducer.currentViewers;

const ViewersReducer = ViewersSlice.reducer;
export default ViewersReducer;
